module.exports = __webpack_public_path__ + "img/drug-30.c3a6b4a0.png";